import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Hash } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, ViewIcon, Menu as MenuIcons, RestoreIcon, SuccessIcon, CloseRedIcon, CheckCircle, TimeIcon, LikeIcon, DislikeIcon } from 'assets/icons';
import { ReportService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
    status: '',
    since: '',
    until: '',
	case: '',
	attempts: '',
	origin: '',
	document_type_id: ''
}

class VerificationReport extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Nombre',
			'Nº de Documento',
			'Origen',
			'Documento',
			'Fecha de Registro',
			'Fecha de Verificación',
			'Intentos',
			'Estado',
			'Motivo'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		verifications_count: 0,
		approved_count: 0,
		rejected_count: 0,
		cases: [],
		unfinish_count: 0
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Reporte de Verificaciones (KYC)',
				onBack: null,
				subtitle: 'Consulta y analiza todas las verificaciones realizadas en el sistema.',
				color: '#ebf9f2',
				icon: MenuIcons.Menu9
			}
		});

		this.loadCases();
		this.load();
	}

	loadCases = async () => {
		const res: any = await ReportService.getCases({
			withoutLoading: true
		});
		this.setState({
			cases: res.verification_cases || []
		});
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await ReportService.getVerifications({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.verifications.rows,
			last_page: res.verifications.count,
			verifications_count: res.count || 0,
			approved_count: res.approved_count || 0,
			rejected_count: res.rejected_count || 0,
			unfinish_count: res.unfinish_count || 0
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	view = (item: any) => {
		window.open(window.location.href + '/view/' + Hash.encryptWithAES(item.id),'_blank');
	}

	getColor = (item: any) => {
		let color = '';

		if (item?.verification?.result) {
			return {
				color: '#4eb686',
				secondary_color: '#eafbf3',
				icon: SuccessIcon
			}
		}
		else {
			return {
				color: '#e73a4c',
				secondary_color: '#feeff1',
				icon: CloseRedIcon
			}
		}

		return color;
	}

	render() {
		return (
			<div id="verifications-report">
				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md">
								<Input
									value={ this.state.form.search }
									name="search"
									placeholder="Buscar"
									label="Buscar por nombre o documento"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md">
								<DatePicker
									label="Desde"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'since'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.since }
								/>
							</div>
							<div className="col-md">
								<DatePicker
									label="Hasta"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'until'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.until }
								/>
							</div>
							<div className="col-md">
								<Select
									color="white"
									placeholder="Seleccionar"
									label="Origen"
									name="origin"
									onChange={ (e: any) => this.change(e,async () => {
										this.load(true);
									}) }
									value={ this.state.form.origin }
									options={ [
										{ value: Constants.ORIGINS.ANDROID.toString(), label: 'Android' },
										{ value: Constants.ORIGINS.IOS.toString(), label: 'iOS' },
										{ value: Constants.ORIGINS.WEB.toString(), label: 'Web' }
									] } />
							</div>
							<div className="col-md">
								<Select
									color="white"
									placeholder="Seleccionar"
									label="Tipo de Documento"
									name="document_type_id"
									onChange={ (e: any) => this.change(e,async () => {
										this.load(true);
									}) }
									value={ this.state.form.document_type_id }
									options={ [
										{ value: Constants.BRAVEALO_DOCUMENT_TYPES.ID.toString(), label: 'Cédula de Identidad (VE)' },
										{ value: Constants.BRAVEALO_DOCUMENT_TYPES.COLOMBIAN_ID.toString(), label: 'Cédula de Identidad (CO)' },
										{ value: Constants.BRAVEALO_DOCUMENT_TYPES.GENERIC_ID.toString(), label: 'Documento de Identidad (Genérico)' },
										{ value: Constants.BRAVEALO_DOCUMENT_TYPES.PASSPORT.toString(), label: 'Pasaporte' },
										{ value: Constants.BRAVEALO_DOCUMENT_TYPES.VEHICLE_CARD.toString(), label: 'Carnet de Circulación' },
										{ value: Constants.BRAVEALO_DOCUMENT_TYPES.MEDICAL_CERTIFICATE.toString(), label: 'Certificado Médico' }
									] } />
							</div>
						</div>
						<div className="row">
							<div className="col-md-6 row">
								<div className="col-md-6">
									<div className="container-inline">
										<p className="label-inline">Estado</p>
										<div className="select-inline">
											<Select
												color="white"
												placeholder="Seleccionar"
												name="status"
												onChange={ (e: any) => this.change(e,() => this.load(true)) }
												value={ this.state.form.status }
												options={ [
													{ value: Constants.IDENTITY_VERIFICATION_RESULT.YES.toString(), label: 'Verificados' },
													{ value: Constants.IDENTITY_VERIFICATION_RESULT.NO.toString(), label: 'Rechazados' },
												] } />
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="container-inline">
										<p className="label-inline">Filtrar por motivo</p>
										<div className="select-inline">
											<Select
												color="white"
												placeholder="Seleccionar"
												name="case"
												onChange={ (e: any) => this.change(e,() => this.load(true)) }
												value={ this.state.form.case }
												options={ this.state.cases.map((item: any) => {
													return {
														value: item.id,
														label: item.name
													}
												}) } />
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6 text-right">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ RestoreIcon } />
											<p>Limpiar</p>
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<div className="container-totals">
					<div className="row">
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#eff2fc' }}>
									<img src={ MenuIcons.Menu5 } className="blue" />
								</div>
								<div>
									<p className="value-top">Total registros</p>
									<p className="value-bottom">{ Globals.formatMiles(this.state.verifications_count,false,'') }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#ebf9f2' }}>
									<img src={ CheckCircle } className="green" />
								</div>
								<div>
									<p className="value-top">Procesados</p>
									<p className="value-bottom">{ Globals.formatMiles(this.state.verifications_count - this.state.unfinish_count,false,'') }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#fef5ea' }}>
									<img src={ TimeIcon } className="orange" />
								</div>
								<div>
									<p className="value-top">No iniciados</p>
									<p className="value-bottom">{ Globals.formatMiles(this.state.unfinish_count,false,'') }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#ecf9f3' }}>
									<img src={ LikeIcon } className="green" />
								</div>
								<div>
									<p className="value-top">Aprobados</p>
									<p className="value-bottom">{ Globals.formatMiles(this.state.approved_count,false,'') }</p>
								</div>
							</div>
						</div>
						<div className="col-md">
							<div className="item-icon">
								<div className="container-icon" style={{ backgroundColor: '#feeeef' }}>
									<img src={ DislikeIcon } className="red" />
								</div>
								<div>
									<p className="value-top">Rechazados</p>
									<p className="value-bottom">{ Globals.formatMiles(this.state.rejected_count,false,'') }</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<Table title="Reporte de Verificaciones" data={ this.state.data.length } header={ this.state.header }
					pagination={
						<Pagination 
							pages={ this.state.last_page } 
							active={ this.state.page }
							onChange={ async (page: number) => {
								await this.setState({
									page: page
								});
								this.load();
							} } />
					}
				>
					{ this.state.data.map((i: any,index: number) => {
						const color: any = this.getColor(i);
						return (
							<tr key={ index } onClick={ () => this.view(i) }>
								<td>
									{
										(i.request_name || i.request_lastname) && (
											<p className="name">{ (i.request_name || '') + ' ' + (i.request_lastname || '') }</p>
										)
									}
									<p className="email">{ i.email }</p>
								</td>
								<td>{ i.verification?.document }</td>
								<td>
									<div className="container-origin">
										{
											i.verification != null && (
												<img src={ Constants.BASE_PUBLIC + i?.verification?.origin?.icon } />
											)
										}
										<p>{ i?.verification?.origin?.name || '-' }</p>
									</div>
								</td>
								<td className="document-type-name">{ i.verification?.document_type?.name || '-' }</td>
								<td className="date">{ moment(i.created_at).isValid() ? moment(i.created_at).format('DD/MM/YYYY HH:mm') : '-' }</td>
								<td className="date">{ i.verification != null && moment(i.verification?.created_at).isValid() ? moment(i.verification?.created_at).format('DD/MM/YYYY HH:mm') : '-' }</td>
								<td>{ i.verifications_count || 0 }</td>
								<td>
									{
										i.verification != null ? (
											<div style={{
												color: color?.color,
												backgroundColor: color?.secondary_color
											}} className="result-container">
												<img src={ color?.icon } />
												{ i?.verification?.result_text || '-' }
											</div>
										) : (
											<>-</>
										)
									}
								</td>
								<td className="container-tags">
									{
										i.verification?.cases?.map((item: any) => {
											return (
												<div className="tag">
													<p>{ item.case?.name }</p>
												</div>
											)
										})
									}
								</td>
							</tr>
						)
					}) }
				</Table>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(VerificationReport);